import { useLocalSearchParams } from 'expo-router';

import {
  ExpoRouterDemoBackButton,
  ExpoRouterDemoScreen,
  ExpoRouterDemoTitle,
} from '../../../components';

// ─────────────────────────────────────────────────────────────────────────────

export default function Page() {
  const { giftCardId } = useLocalSearchParams<{ giftCardId?: string[] }>();

  return (
    <ExpoRouterDemoScreen>
      <ExpoRouterDemoTitle>
        Redeem Gift Card{giftCardId ? ` — ${giftCardId[0]}` : ''}
      </ExpoRouterDemoTitle>
      <ExpoRouterDemoBackButton href="/" label="Close" dismiss />
    </ExpoRouterDemoScreen>
  );
}
